/* import __COLOCATED_TEMPLATE__ from './input-select.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

/**
 * This component is a thin wrapper around <market-select> web component
 *
 * ```
 * <Prism::InputSelect
 *   id="my-id"
 *   @value={{this.nameOfValueProperty}}
 *   @class="some-class some-other-class"
 *   @options={{this.options}}
 *   @label="Name"
 *   @placeholder="Put you name here"
 *   @onChange={{action (mut nameOfValueProperty))}}
 * />
 * ```
 *
 */
export default Component.extend({
  tagName: '',
  /**
   * @param {String} class - Class to apply to the underlying market-select
   */
  class: null,
  /**
   * @param {String} label - Label for the input
   */
  label: null,
  /**
   * @param {String} value - The value passed. This is only relevant to set the initial value of thea field.
   */
  value: null,
  /**
   * @param {String} name - name for the input
   */
  name: null,
  /**
   * @param {Boolean} readonly - is the input readonly
   */
  readonly: false,
  /**
   * @param {Boolean} disabled - is the input disabled
   */
  disabled: false,
  /**
   * @param {Boolean} focused - is the input focused
   */
  focused: false,
  /**
   * @param {Object} validation
   * @param {Boolean} validation.isInvalid - whether or not the field is invalid
   * @param {Boolean} validation.message - validation message to display below the field
   */
  validation: null,
  /**
   * @param {Boolean} showValidation - whether or not the validation is ready to be shown
   */
  showValidation: false,
  /**
   * @param {Array<Object>} options - array of options for the select element
   * @param {String} options.label - label for the option
   * @param {String} options.value - value for the option
   */
  options: null,
  /**
   * @param {Boolean} formGroupError - hide the input's error message, since it will be shown once for the whole group
   */
  formGroupError: false,
  /**
   * @param {Action} [onChange] action triggered when the select value changes
   */
  onChange() {},
  showError: computed('showValidation', 'validation.isInvalid', function () {
    if (!this.validation) {
      return false;
    }
    return this.validation.isInvalid && this.showValidation;
  }),
  actions: {
    _onChange(event) {
      this.onChange(event.detail.value, event);
    }
  }
});